module.exports = __webpack_public_path__ + "static/premier-logo-71b088f415b7060c9286213ee2100214.svg";